<template>
  <span>
    <template v-if="showPdas">
      <component :is="componentName" />
    </template>
    <template v-else>
      <detail />
    </template>
  </span>
</template>
<script>
/* This Detail veiw is used for GC-US */
import Detail from './Details.vue';
/* This Detail veiw is used for PDAS */
import DetailPdas from './Details_pdas.vue';
/* This Detail veiw is used for GC India 2.0 */
import DetailV3 from './Version3/DetailsV3.vue';
/* This Detail veiw is Copy of Details_pdas.vue with simplified implimented */
import DetailV4 from './Version4/DetailsV4.vue';
/* This Detail veiw is Copy of DetailV4.vue with simplified + UPD implimented */
import DetailV5 from './Version5/DetailsV5.vue';
/* This Detail veiw is used for GC India 2.0  with new exclude aux par implementation */
import DetailV6 from './Version6/DetailsV6.vue';
/* This Detail veiw is used for GC India 2.0  with new UPD for asia */
import DetailV7 from './Version7/DetailsV7.vue';

export default {
  name: 'DashbhoardHome',
  components: {
    Detail,
    DetailPdas,
    DetailV3,
    DetailV4,
    DetailV5,
    DetailV6,
    DetailV7,
  },
  data() {
    return {
      showPdas: this.$cgiSettings.showPdas,
      componentName: (this.$cgiSettings.detailsForm && this.$cgiSettings.detailsForm.componentName) ? this.$cgiSettings.detailsForm.componentName : 'DetailPdas',
    };
  },
};
</script>
